import { useState, useEffect, useMemo } from "react";

// Material UI components
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Page components
import CountrySelectForm from "layouts/dashboards/analytics/components/Export1CountryForm/sections/CountrySelectForm";

import AgeGroupsForm from "layouts/dashboards/analytics/components/CountryForm/sections/ageGroupsForm";
import SurvivalLastYearForm from "layouts/dashboards/analytics/components/CountryForm/sections/survivalLastYearForm";
import IncidenceAgeScalingForm from "layouts/dashboards/analytics/components/CountryForm/sections/incidenceAgeScalingForm";
import IncidenceRatesForm from "layouts/dashboards/analytics/components/CountryForm/sections/incidenceRatesForm";
import InsulinForm from "layouts/dashboards/analytics/components/CountryForm/sections/insulinForm";
import CumulativesSurvForm from "layouts/dashboards/analytics/components/CountryForm/sections/cumulativesSurvForm";
import CumulativesIncForm from "layouts/dashboards/analytics/components/CountryForm/sections/cumulativesIncForm";

// Contexts
import { useUserContext } from "contexts/contextUser";

function ExportCountryForm({ formData }: { formData: any }): JSX.Element {
  const { isAuthenticated } = useUserContext();
  const isAuth = Boolean(isAuthenticated);

  return (
    <MDBox sx={{ marginTop: 2, marginBottom: 2 }}>
      <CountrySelectForm formData={formData} />

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <MDTypography variant="h6">Age Groups Settings</MDTypography>
        </AccordionSummary>
        <AccordionDetails>
          <AgeGroupsForm formData={formData} />
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <MDTypography variant="h6">Survival Settings</MDTypography>
        </AccordionSummary>
        <AccordionDetails>
          <SurvivalLastYearForm formData={formData} />
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <MDTypography variant="h6">Incidence Settings</MDTypography>
        </AccordionSummary>
        <AccordionDetails>
          <IncidenceAgeScalingForm formData={formData} />
          <IncidenceRatesForm formData={formData} />
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <MDTypography variant="h6">Insulin Settings</MDTypography>
        </AccordionSummary>
        <AccordionDetails>
          <InsulinForm formData={formData} />
        </AccordionDetails>
      </Accordion>

      {isAuth && (
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <MDTypography variant="h6">Cumulative outputs settings</MDTypography>
          </AccordionSummary>
          <AccordionDetails>
            <CumulativesSurvForm formData={formData} />
            <CumulativesIncForm formData={formData} />
          </AccordionDetails>
        </Accordion>
      )}
    </MDBox>
  );
}

export default ExportCountryForm;
